import { render, staticRenderFns } from "./UsuarioAlliance.vue?vue&type=template&id=03d814f7&scoped=true"
import script from "./UsuarioAlliance.vue?vue&type=script&lang=js"
export * from "./UsuarioAlliance.vue?vue&type=script&lang=js"
import style0 from "./UsuarioAlliance.vue?vue&type=style&index=0&id=03d814f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d814f7",
  null
  
)

export default component.exports